import { Outlet, useLocation, useNavigate } from 'react-router-dom';

import { DialogID, useDialog } from '@components/Dialog';
import { Layout } from '@components/Layout';
import { paths } from '@constants/paths';
import { MobileProvider } from '@features/Mobile/Provider';
import { useMobileContext } from '@features/Mobile/Provider/Context';
import { withProfiler } from '@services/sentry/withProfiler';

const MobileOutlet = () => {
  const navigate = useNavigate();
  const { pathname } = useLocation();
  const { handleGoBack, hasFormChanged } = useMobileContext();
  const saveChangesDialog = useDialog(DialogID.SAVE_CHANGES_MOBILE);

  const handleBack = () => {
    if (pathname === paths.mobile) {
      if (hasFormChanged) {
        saveChangesDialog.setOpen(true);
        return;
      }

      return navigate(paths.bundle);
    }

    handleGoBack();
    return navigate(paths.mobile);
  };

  return (
    <Layout
      title="Mobile"
      onBack={handleBack}
      backButtonLabel={
        pathname === paths.mobile ? 'Back to bundle' : 'Back to SIM selection'
      }
    >
      <Outlet />
    </Layout>
  );
};

const MobileProviderUnwrapped = () => (
  <MobileProvider>
    <MobileOutlet />
  </MobileProvider>
);

const Mobile = withProfiler(MobileProviderUnwrapped);

export { Mobile };
